import { render, staticRenderFns } from "./VeHrGangweiList.vue?vue&type=template&id=bb20fd0e&scoped=true"
import script from "./VeHrGangweiList.vue?vue&type=script&lang=js"
export * from "./VeHrGangweiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20fd0e",
  null
  
)

export default component.exports